﻿import { getSchema } from "./API/Schema/Schema";
import { StaticSchema } from "./API/Schema/StaticSchema";

export class StaticDataManager {

    public Schema: StaticSchema = null;

    public getStaticData(callback: (errOut: any) => any): void {

        getSchema((err: any, data: StaticSchema) => {
            this.Schema = data;
            callback(err);
        });
        
    }
}